<template>
  <div>
    <div class="page404">
      <h2 v-translate>Oeuvre non présente dans la publication Navigart</h2>
    </div>
    <div class="art-navigation">
      <a href="/" class="art-close"><i class="icon-CLOSE"></i></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>
